<template>
  <div
    v-if="loaded"
    class="dg-lookup-control"
    :class="{ _hasAddVal: control.ableToAddLookUpVal && !control.readonly }"
  >
    <div>
      <div class="row lookUpControl" v-if="labelPosition === 'left'">
        <div class="col-md-4">
          <label
            class="form-control-label"
            :class="{
              bold: control.labelBold,
              italic: control.labelItalic,
              underline: control.labelUnderline,
            }"
            >{{ control.label }}</label
          >
        </div>
        <div class="col-md-8">
          <multiselect
            v-model="selectedLookUp"
            :options="lookups"
            track-by="value"
            label="text"
            selectLabel
            selectedLabel
            tagPlaceholder
            placeholder
            deselectLabel
            :searchable="true"
            :allow-empty="false"
            openDirection="bottom"
            @select="save"
            :disabled="control.readonly"
          />
        </div>
      </div>
      <div class="lookUpControl" v-else>
        <label
          class="form-control-label"
          :class="{
            bold: control.labelBold,
            italic: control.labelItalic,
            underline: control.labelUnderline,
          }"
          >{{ control.label }}</label
        >
        <div>
          <multiselect
            v-model="selectedLookUp"
            :options="lookups"
            track-by="value"
            label="text"
            selectLabel
            selectedLabel
            tagPlaceholder
            placeholder
            deselectLabel
            :searchable="true"
            :allow-empty="false"
            openDirection="bottom"
            @select="save"
            :disabled="control.readonly"
          />
        </div>
      </div>
    </div>
    <div
      v-if="control.ableToAddLookUpVal && !control.readonly"
      class="dg-lookup-control__addVal"
    >
      <a href="#" @click.prevent="showLookUpModal">
        <icon name="plus" />
      </a>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { find } from 'lodash'

export default {
  props: ['control', 'labelPosition'],
  data() {
    return {
      value: this.control.value,
      rowKey: null,
      cellKey: null,
      cellVal: null,
      options: null,
      lookUpTable: null,
      formBuilderInst: null,
      loaded: false,
    }
  },
  watch: {
    'control.value'(value) {
      this.value = value
    }
  },
  computed: {
    ...mapState(['dataGrid_options']),
    selectedLookUp: {
      get() {
        if (this.value) {
          const selectedLookUp = (this.selectedLookUp = find(this.lookups, {
            value: this.value,
          }))

          return selectedLookUp
            ? selectedLookUp
            : { value: null, text: 'BLANK' }
        }
        return { value: null, text: 'BLANK' }
      },
      set(newLookUp) {
        this.value = newLookUp ? newLookUp.value : null
      },
    },
    lookUpTableDisplayColumn() {
      return this.dataGrid_options[this.lookUpTable].displayColumn
    },
    lookups() {
      const lookups = [{ value: null, text: 'BLANK' }]
      const lookUpTableVals = $getGrid(this.lookUpTable)

      if (lookUpTableVals) {
        lookUpTableVals.map(row => {
          lookups.push({
            text: row[this.lookUpTableDisplayColumn],
            value: row.rowKey,
          })
        })
      }

      return lookups
    },
  },
  methods: {
    save(newLookUp) {
      this.value = newLookUp.value

      this.$nextTick(() => {
        this.formBuilderInst.setRowDataVal(this.cellKey, newLookUp.value)
      })
    },
    showLookUpModal() {
      $dgAddRow(this.lookUpTable).then(rowKey => {
        $dgShowEditRowModal(this.lookUpTable, rowKey)
        this.selectedLookUp = { text: '', value: rowKey }
        this.save()
      })
    },
  },
  created() {
    this.$nextTick(() => {
      this.formBuilderInst = this.$instByClass(this, 'form-builder-root')
      this.gridId = this.formBuilderInst.gridId
      this.rowKey = this.formBuilderInst.rowKey
      this.cellKey = this.control.propName
      this.options = this.dataGrid_options[this.formBuilderInst.gridId]
      this.lookUpTable = this.dataGrid_options[this.gridId].meta[
        this.cellKey
      ].lookUpTable
      this.loaded = true
    })
  },
}
</script>
